import React, { Component } from 'react'


export default class VideoListItem extends Component {
  render() {
    const { video } = this.props
    return (
      <div className="col-lg-3">
        <div className="video-item" onClick={e => this.props.onPlay(video)}>
          <img className="videoThumbnail" src={video.thumbnail} alt="" />
          <div className="video-actions">
            <div className="play" onClick={e => this.props.onPlay(video)} >
              <i className="fa fa-play fa-3x" aria-hidden="true"></i>
            </div>
            <div className="trash" onClick={e => this.props.onDelete(video)} >
              <i className="fa fa-trash-o fa-2x" aria-hidden="true"></i>
            </div>
          </div>
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/VideoListItem.js